import React, { useState, useEffect } from "react";
import QRCode from "qrcode.react"; // Import a QR code library
import {
  Box,
  Typography,
  Button,
  InputBase,
  Avatar,
  Tooltip,
} from "@mui/material"; // Import Material UI components
import ContentCopyIcon from "@mui/icons-material/ContentCopy"; // Copy icon
import {
  readTransactionFromWallet,
  getEnrollmentIdFromWallet,
} from "../extensionMethods/app";
import config from "../config";
import BigNumber from "bignumber.js";
import CopyIcon from "../assets/copy-icon.png";
import AvatarIcon from "../assets/avatar.png";
import formatAddress from "../utils";

const ScanQR = ({ balance, vendorAddress, isConnected }) => {
  const [qrCode, setQrCode] = useState("");
  const [vendorAddressError, setVendorAddressError] = useState(false);
  const [amountError, setAmountError] = useState(false);
  const [copyLinkClicked, setCopyLinkClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (isConnected) {
      setLoading(true);
      const timer = setTimeout(() => setLoading(false), 1000);
      return () => clearTimeout(timer);
    } else {
      setLoading(false);
    }
  }, [isConnected]);

  const handleGenerateQR = () => {
    let isValid = true;

    // Validate vendorAddress
    if (!vendorAddress) {
      setVendorAddressError(true);
      isValid = false;
    } else {
      setVendorAddressError(false);
    }

    if (!isValid) return;

    const qrPayload = {
      enrollmentId: vendorAddress,
      network: config.NETWORK_NAME,
      runtimeType: "receiveToken",
    };

    const qrString = JSON.stringify(qrPayload);
    setQrCode(qrString);
  };

  // Function to copy vendorAddress to clipboard
  const handleCopy = () => {
    navigator.clipboard.writeText(vendorAddress);
    setCopyLinkClicked(true);
    setTimeout(() => setCopyLinkClicked(false), 2000);
  };

  return (
    <Box sx={{ padding: "30px", textAlign: "center", width: "75%" }}>
      {/* Profile Image and QR Code Section */}
      <Box
        sx={{
          display: "flex",
          position: "relative",
          flexDirection: "column",
          alignItems: "center",
          marginBottom: "20px",
          width: "100%",
        }}
      >
        <Avatar
          alt="User"
          src={AvatarIcon}
          sx={{ width: 80, height: 80, position: "absolute", top: -50 }}
        />
        <Box
          sx={{
            backgroundColor: "#fff",
            padding: "50px",
            borderRadius: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          {qrCode ? (
            <>
              <QRCode value={qrCode} size={150} />
              <Typography variant="caption" sx={{ marginTop: "10px" }}>
                Scan to Pay
              </Typography>
            </>
          ) : (
            <Typography>QR Code Will Appear Here</Typography>
          )}
          {/* The QR Code and Typography are now on separate lines */}
        </Box>
      </Box>

      {/* Vendor Address Display */}
      {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f4f4f4', padding: '10px', borderRadius: '8px', marginBottom: '20px' }}>
        <InputBase
          sx={{ width: '100%', fontSize: '16px', color: '#555' }}
          value={vendorAddress}
          readOnly
        />
        <Button sx={{ marginLeft: '10px' }} onClick={handleCopy}><ContentCopyIcon /></Button>
      </Box> */}

      {/* Vendor Address Display with Error Handling */}
      <Box
        sx={{
          marginBottom: "20px",
          display: "flex",
          alignItems: "center",
          gap: 1,
          padding: "5px",
          backgroundColor: "#fff",
          borderRadius: "12px",
        }}
      >
        <InputBase
          sx={{
            width: "100%",
            fontSize: "16px",
            color: "#000",
            padding: "10px",
            borderRadius: "8px",
            border: vendorAddressError ? "1px solid red" : "none",
          }}
          value={vendorAddress}
          placeholder="Enter user's address"
          readOnly
        />
        {isConnected && (
          <Tooltip
            title={
              copyLinkClicked ? "Address Copied To Clipboard" : "Copy Address"
            }
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                fontSize: "15px",
                color: "#0033cc",
                marginRight: 1,
                cursor: "pointer",
              }}
              onClick={handleCopy}
            >
              <img src={CopyIcon} />
              Copy
            </Box>
          </Tooltip>
        )}
      </Box>
      {vendorAddressError && (
        <Typography sx={{ color: "red", fontSize: "12px" }}>
          Vendor address is required
        </Typography>
      )}

      {/* Amount Input */}
      {/* <Box sx={{ marginBottom: '20px' }}>
        <InputBase
          type="number"
          placeholder="Enter Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          sx={{ backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '8px', width: '100%' }}
        />
      </Box> */}

      {/* Amount Input with Error Handling */}

      {/* Generate QR Button */}
      {!qrCode && (
        <Button
          variant="contained"
          onClick={handleGenerateQR}
          disabled={!isConnected}
          sx={{
            backgroundColor: "#0033cc",
            color: "#fff",
            width: "100%",
            padding: "10px",
            borderRadius: "8px",
          }}
        >
          Generate QR Code
        </Button>
      )}

      {/* Balance Display */}
      {isConnected && (
        <Box
          sx={{
            marginTop: "20px",
            display: "flex",
            gap: "4px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="body2">Balance:</Typography>
          <Typography
            variant="body2"
            sx={{ color: "#0033cc", fontWeight: "bold" }}
          >
            {loading
              ? "Loading"
              : !loading &&
                isConnected &&
                !isNaN(Number(balance)) &&
                Number(balance) > 0
              ? `₹${new BigNumber(balance).toFormat(2)}`
              : `₹0.00`}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ScanQR;
